import { Flex } from '@sequencehq/core-components'
import { StepFooter } from '../components/StepFooter'
import { StepLayout } from '../components/StepLayout'
import { StepTitle } from '../components/StepTitle'
import { SchedulePricing } from './components/SchedulePricing'
import {
  showValidationErrorsAtom,
  stepIsValidAtom
} from './atoms/reviewPricing.validation.atoms'
import { useAtomValue, useSetAtom } from 'jotai'
import { ReviewPricingStepData } from './atoms/reviewPricing.primitives.atoms'
import { reviewPricingFeaturesAtom } from './atoms/reviewPricing.features.atoms'
import { Step, StepComponentProps } from '../steps.types'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { useEffect } from 'react'

const REVIEW_PRICING_STEP_WIDTH = '760px'

export type ReviewPricingStep = Step<'REVIEW_PRICING', ReviewPricingStepData>

export const ReviewPricing = (props: StepComponentProps) => {
  const setShowValidationErrors = useSetAtom(showValidationErrorsAtom)
  const isStepValid = useAtomValue(stepIsValidAtom)
  useSyncFeatureFlagsToAtom()

  return (
    <StepLayout
      data-testid="reviewPricing"
      title={<StepTitle>Pricing</StepTitle>}
      footer={
        <StepFooter
          onNext={async () => {
            if (!isStepValid) {
              setShowValidationErrors(true)
              return
            }

            await props.onNext()
          }}
          finalStepButtonText="Complete review"
          onBack={() => props.onBack()}
        />
      }
    >
      <Flex direction="column" gap="24px" width={REVIEW_PRICING_STEP_WIDTH}>
        <SchedulePricing />
      </Flex>
    </StepLayout>
  )
}

/**
 * The pricing atoms branch on feature flags, and an atom cannot read a hook.
 * The step reads the flags here and writes them to the features atom the
 * derived atoms depend on.
 */
const useSyncFeatureFlagsToAtom = () => {
  const { useStackedDiscounts } = useFeatureFlags()
  const setFeatures = useSetAtom(reviewPricingFeaturesAtom)

  useEffect(() => {
    setFeatures({ stackedDiscounts: useStackedDiscounts })
  }, [useStackedDiscounts, setFeatures])
}
